import '../Scripts/jqwidgets/jqxcore'

import '../Scripts/jqwidgets/jqxdata'
import '../Scripts/jqwidgets/jqxdraw'
import '../Scripts/jqwidgets/jqxchart.core'

function requireAll(r) { r.keys().forEach(r); }
requireAll(require.context('../Scripts/chart-script', true, /\.js$/));
